import { render, staticRenderFns } from "./InviraRolesPermissions.vue?vue&type=template&id=e4760498&scoped=true"
import script from "./InviraRolesPermissions.vue?vue&type=script&lang=js"
export * from "./InviraRolesPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4760498",
  null
  
)

export default component.exports